var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMarkDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1692_65390)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.825,
    cy: 32.0008,
    r: 19.575,
    fill: "#B83739"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1527 21.8753C28.1386 21.4798 28.1245 21.1337 28.1104 20.8371C28.1104 20.5263 28.1033 20.258 28.0892 20.0319C28.0892 19.7918 28.0821 19.5799 28.068 19.3963C28.068 19.1986 28.068 19.0149 28.068 18.8454C28.068 18.5205 28.1245 18.2168 28.2375 17.9343C28.3505 17.6518 28.5341 17.4117 28.7884 17.214C29.0426 17.0021 29.3675 16.8396 29.763 16.7266C30.1726 16.5995 30.66 16.5359 31.225 16.5359C31.8041 16.5359 32.2914 16.5995 32.6869 16.7266C33.0966 16.8396 33.4215 17.0021 33.6616 17.214C33.9158 17.4117 34.0995 17.6518 34.2125 17.9343C34.3255 18.2168 34.382 18.5205 34.382 18.8454C34.382 19.0149 34.382 19.1986 34.382 19.3963C34.382 19.5799 34.3749 19.7918 34.3608 20.0319C34.3608 20.258 34.3537 20.5263 34.3396 20.8371C34.3396 21.1337 34.3325 21.4798 34.3184 21.8753L33.8311 37.0247C33.8028 37.6179 33.5768 38.0982 33.1531 38.4654C32.7293 38.8327 32.0866 39.0163 31.225 39.0163C30.3775 39.0163 29.7348 38.8327 29.2969 38.4654C28.8731 38.0982 28.6542 37.6179 28.64 37.0247L28.1527 21.8753ZM27.6018 44.9913C27.6018 44.4828 27.6937 44.0167 27.8773 43.5929C28.0609 43.155 28.3152 42.7807 28.64 42.47C28.9791 42.1451 29.3675 41.8979 29.8054 41.7284C30.2574 41.5447 30.7447 41.4529 31.2674 41.4529C31.8041 41.4529 32.2914 41.5377 32.7293 41.7072C33.1672 41.8767 33.5415 42.1168 33.8523 42.4276C34.1772 42.7242 34.4244 43.0844 34.5939 43.5082C34.7775 43.9319 34.8693 44.3981 34.8693 44.9066C34.8693 45.4151 34.7775 45.8812 34.5939 46.305C34.4102 46.7287 34.156 47.103 33.8311 47.4279C33.5062 47.7387 33.1178 47.9788 32.6658 48.1483C32.2137 48.3319 31.7194 48.4238 31.1826 48.4238C30.6458 48.4238 30.1585 48.339 29.7206 48.1695C29.2827 48 28.9084 47.7669 28.5977 47.4703C28.2869 47.1595 28.0397 46.7994 27.8561 46.3897C27.6866 45.966 27.6018 45.4998 27.6018 44.9913Z",
    fill: "#FFFEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1692_65390",
    x: 0.0999994,
    y: 0.275781,
    width: 63.45,
    height: 63.4484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1692_65390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1692_65390",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkDark);
export default __webpack_public_path__ + "static/media/exclamation_mark_dark.dfefab3c199f06c6851eb5e20cb7bdf9.svg";
export { ForwardRef as ReactComponent };